import { render, staticRenderFns } from "./Soccer.vue?vue&type=template&id=5ba01804&scoped=true&"
import script from "./Soccer.vue?vue&type=script&lang=js&"
export * from "./Soccer.vue?vue&type=script&lang=js&"
import style0 from "./Soccer.vue?vue&type=style&index=0&id=5ba01804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba01804",
  null
  
)

export default component.exports